module.exports = __webpack_public_path__ + "static/media/sf-test-8.96ac7857.mp3";